module.exports = __webpack_public_path__ + "img/nik_needham.72082739.png";